<template>
  <div class="px-8 py-1">
    <v-container grid-list-xl fluid class="px-0">
      <v-flex xs12 mb-3>
        <h2 class="darkblue--text fs-16 lh-16 font-weight-700">
          COST CENTER
        </h2>
        <v-breadcrumbs class="px-0" :items="breadcrumbs"></v-breadcrumbs>
      </v-flex>
      <v-card>
        <v-card-title>
          <v-flex xs9>
            {{ id ? 'Edit Cost Center' : 'Create New Cost Center' }}
          </v-flex>
          <v-flex xs3 class="text-right">
            <v-icon id="refresh" @click="clear" title="refresh">
              refresh
            </v-icon>
          </v-flex>
        </v-card-title>
        <ValidationObserver ref="obs">
          <v-form @submit.prevent="save" class="pa-5">
            <v-layout>
              <v-flex xs6 class="pa-0">
                <ValidationProvider
                  name="code"
                  rules="required"
                  v-slot="{ errors, valid }"
                >
                  <label class="darkblue--text pl-5">Code</label>
                  <v-text-field
                    id="name"
                    single-line
                    outlined
                    placeholder="Code"
                    dense
                    v-model="items.code"
                    required
                    :error-messages="errors"
                    :success="valid"
                    class="px-4"
                  ></v-text-field>
                </ValidationProvider>
              </v-flex>
              <v-flex xs6 class="pa-0">
                <ValidationProvider
                  name="Description"
                  rules="required"
                  v-slot="{ errors, valid }"
                >
                  <label class="darkblue--text pl-5">Description</label>
                  <v-text-field
                    id="description"
                    single-line
                    outlined
                    placeholder="Description"
                    dense
                    v-model="items.desc"
                    required
                    :error-messages="errors"
                    :success="valid"
                    class="px-4"
                  ></v-text-field>
                </ValidationProvider>
              </v-flex>
            </v-layout>
            <v-flex xs6 class="pa-0">
              <ValidationProvider
                name="Working / Non Working"
                rules="required"
                v-slot="{ errors, valid }"
              >
                <label class="darkblue--text pl-2">Working / Non Working</label>
                <v-autocomplete
                  id="category"
                  single-line
                  outlined
                  dense
                  label="Working / Non Working"
                  v-model="items.type"
                  required
                  :items="['working', 'non working']"
                  :error-messages="errors"
                  :success="valid"
                  class="pl-1 pr-4 text-capitalize"
                ></v-autocomplete>
              </ValidationProvider>
            </v-flex>
            <v-card-actions class="text-right pt-9">
              <v-spacer></v-spacer>
              <v-flex xs2 right class="mr-4">
                <v-btn
                  id="btn-cancel"
                  dark
                  rounded
                  color="red"
                  block
                  :to="{ name: 'costCenter' }"
                >
                  Cancel
                </v-btn>
              </v-flex>
              <v-flex xs2 right>
                <v-btn
                  id="btn-update"
                  dark
                  rounded
                  color="blue darken-3"
                  block
                  v-if="id"
                  type="submit"
                  >Update</v-btn
                >
                <v-btn
                  id="btn-save"
                  dark
                  rounded
                  color="blue darken-3"
                  block
                  v-else
                  type="submit"
                  >Save</v-btn
                >
              </v-flex>
            </v-card-actions>
          </v-form>
        </ValidationObserver>
      </v-card>
    </v-container>
    <progress-dialog :show="progressDialogLoading" text="Please wait">
    </progress-dialog>
  </div>
</template>

<script>
import ProgressDialog from '../../../components/progress_dialog';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';

export default {
  components: { 'progress-dialog': ProgressDialog },
  $_veeValidate: {
    validator: 'new'
  },
  data() {
    return {
      isEdit: false,
      text: '',
      progressDialogLoading: true,
      loading: true,
      items: {
        code: '',
        desc: ''
      },
      search: '',
      breadcrumbs: [
        {
          text: 'Master Data',
          disabled: true,
          href: 'breadcrumbs_dashboard'
        },
        {
          text: 'Cost Center List',
          disabled: true,
          href: 'breadcrumbs_link_1'
        },
        {
          text: this.id ? 'Edit Cost Center' : 'Create New Cost Center',
          disabled: true,
          href: 'breadcrumbs_link_1'
        }
      ]
    };
  },
  props: ['id'],
  mounted() {
    if (this.id) {
      this.getDetail();
    } else {
      setTimeout(() => {
        this.progressDialogLoading = false;
        this.loading = false;
      }, 1000);
    }
  },
  methods: {
    getDetail() {
      this.progressDialogLoading = true;
      this.loading = true;
      this.$store
        .dispatch('costCenter/detail', this.id)
        .then(data => {
          this.progressDialogLoading = false;
          this.loading = false;
          if (data.code === 200) {
            this.items = data.data.result;
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    async clear() {
      this.items = {
        code: '',
        desc: ''
      };
      requestAnimationFrame(() => {
        this.$refs.obs.reset();
      });
    },
    async save() {
      const validated = await this.$refs.obs.validate();
      if (validated) {
        this.progressDialogLoading = true;
        this.loading = true;
        if (this.id) {
          this.$store
            .dispatch('costCenter/update', { id: this.id, params: this.items })
            .then(data => {
              this.progressDialogLoading = false;
              this.loading = false;
              if (data.code === 200) {
                Swal.fire('Success!', data.message.text_en, 'success');
                this.clear();
                this.$router.push({
                  name: 'costCenter'
                });
              } else {
                Swal.fire(
                  'Failed!',
                  data.response.data.message.text_en,
                  'error'
                );
              }
            })
            .catch(err => {
              Swal.fire('Failed!', err.response.data.message.text_en, 'error');
              this.progressDialogLoading = false;
              this.loading = false;
            });
        } else {
          this.$store
            .dispatch('costCenter/create', this.items)
            .then(data => {
              this.progressDialogLoading = false;
              this.loading = false;
              if (data.code === 200) {
                Swal.fire('Success!', data.message.text_en, 'success');
                this.clear();
                this.$router.push({
                  name: 'costCenter'
                });
              } else {
                Swal.fire(
                  'Failed!',
                  data.response.data.message.text_en,
                  'error'
                );
              }
            })
            .catch(err => {
              Swal.fire('Failed!', err.response.data.message.text_en, 'error');
              this.progressDialogLoading = false;
              this.loading = false;
            });
        }
      }
    }
  }
};
</script>
